<template>
  <main class="c-main">
    <b-row class="justify-content-between">
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-primary">
          <b-card-body class="pb-0">
            <h4 class="mb-0">{{ data.categories.count }}</h4>
            <p class="cursor" :class="{'text-underline': activeTab == 0}" @click="show(0)">Категории</p>
          </b-card-body>
        </b-card>
        <translation :translations="data.categories.translation" :title="'категорий'"/>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-warning">
          <b-card-body class="pb-0">
            <h4 class="mb-0">{{ data.products.count }}</h4>
            <p class="cursor" :class="{'text-underline': activeTab == 1}" @click="show(1)">Классы</p>
          </b-card-body>
        </b-card>
        <translation :translations="data.products.translation" :title="'классов'"/>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-dark">
          <b-card-body class="pb-0">
            <h4 class="mb-0">{{ data.fields.count }}</h4>
            <p class="cursor" :class="{'text-underline': activeTab == 2}" @click="show(2)">Свойства</p>
          </b-card-body>
        </b-card>
        <translation :translations="data.fields.translation" :title="'свойств'"/>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-dark">
          <b-card-body class="pb-0">
            <h4 class="mb-0">{{ data.field_values.count }}</h4>
            <p class="cursor" :class="{'text-underline': activeTab == 3}" @click="show(3)">Значения свойства</p>
          </b-card-body>
        </b-card>
        <translation :translations="data.field_values.translation" :title="'Значения свойства'"/>
      </b-col>
    </b-row>
  </main>
</template>

<script>
import { GET } from "@/shared/api";
import Translation from './Component/TranslationStat.vue'
export default {
  data() {
    return {
			data: {
        categories: {
          count: 0,
          translation: []
        },
        products: {
          count: 0,
          translation: []
        },
        fields: {
          count: 0,
          translation: []
        },
        field_values: {
          count: 0,
          translation: []
        }
      },
			filter: {},
			activeTab: 0
    };
  },
  components:{
    "translation": Translation
  },
  methods: {
    getData() {
      GET([], "/report", this, false).then(response => {
        this.data = response;
      });
		},
		show(index) {
			this.activeTab = index
			this.$emit('show', index)
		}
  },
  mounted() {
    this.getData();
  }
};
</script>
